import * as React from "react";
import { CircularProgress, TextField, Typography } from "@mui/material";
import { AuthLayout, Eyebrow, Heading, Notice, PrimaryButton, fieldSx } from "../authShared";
import { NAME_MAX, nameLooksValid, saveAccountName } from "../../auth/accountName";

// ─────────────────────────────────────────────────────────────────────────────
// "Name this account" — shown by ProtectedRoute, once, before the Studio opens
// for an account that has no name yet: accounts made before names existed, and
// accounts made in the Fennira Broadcast app (which can't ask). PLAN.md, D3.
// ─────────────────────────────────────────────────────────────────────────────

export default function NameAccount({ onDone }) {
  const [name, setName] = React.useState("");
  const [busy, setBusy] = React.useState(false);
  const [error, setError] = React.useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!nameLooksValid(name)) return;
    setBusy(true); setError("");
    try {
      await saveAccountName(name);
      onDone();
    } catch (err) {
      setError(err?.response?.data?.message || "That didn't work. Please try again.");
      setBusy(false);
    }
  };

  return (
    <AuthLayout
      panel={{
        eyebrow: "One more step",
        heading: "Give your studio a name.",
        body: "It tells your accounts apart: in the Studio, and on your passkeys when you sign in."
      }}
    >
      <Eyebrow>Your account</Eyebrow>
      <Heading>Name this account</Heading>
      <Typography sx={{ color: "var(--fn-muted-l)", fontSize: 16, mb: 3.5 }}>
        Your name, your studio's or your show's. You can change it later in your profile.
      </Typography>
      {error && <Notice onClose={() => setError("")}>{error}</Notice>}
      <form onSubmit={submit} noValidate>
        <TextField fullWidth autoFocus label="Account name" placeholder="Account name or your name"
          value={name} onChange={(e) => setName(e.target.value)} disabled={busy}
          inputProps={{ maxLength: NAME_MAX, autoComplete: "organization" }} sx={{ ...fieldSx, mb: 2.5 }} />
        <PrimaryButton type="submit" disabled={busy || !nameLooksValid(name)}>
          {busy ? <CircularProgress size={21} thickness={5} sx={{ color: "var(--fn-cream)" }} /> : "Continue"}
        </PrimaryButton>
      </form>
    </AuthLayout>
  );
}
